export default __webpack_public_path__ + "static/media/OutWash.e8b4576f.png";